import { IBbitGeoCoordinates } from '@bbitgmbh/bbit.utils';
import { fromLonLat, toLonLat } from 'ol/proj';

// functions copied from https://github.com/manuelbieh/geolib

export class BbitMapHelper {
  static toOlCoordinates(coordinates: IBbitGeoCoordinates): number[] {
    return fromLonLat([coordinates.lng, coordinates.lat]);
  }

  static toBbitCoordinates(coordinates: number[]): IBbitGeoCoordinates {
    const result = toLonLat(coordinates);
    return {
      lng: result[0],
      lat: result[1],
    };
  }

  // private static _constants = {
  //   EARTH_RADIUS: 6378137,
  //   MAX_DISTANCE_IN_KM: 20039,
  // };

  // private static _toRad(value: number): number {
  //   return (value * Math.PI) / 180;
  // }

  // private static _toDeg(value: number): number {
  //   return (value * 180) / Math.PI;
  // }

  // private static _robustAcos(value: number): number {
  //   if (value > 1) {
  //     return 1;
  //   }
  //   if (value < -1) {
  //     return -1;
  //   }
  //   return value;
  // }

  // static getDistance(from: IBbitGeoCoordinates, to: IBbitGeoCoordinates, accuracy = 1): BbitUnit {
  //   accuracy = typeof accuracy !== 'undefined' && !isNaN(accuracy) ? accuracy : 1;

  //   const fromLat = from.lat;
  //   const fromLon = from.lng;
  //   const toLat = to.lat;
  //   const toLon = to.lng;

  //   const distance =
  //     Math.acos(
  //       BbitMapHelper._robustAcos(
  //         Math.sin(BbitMapHelper._toRad(toLat)) * Math.sin(BbitMapHelper._toRad(fromLat)) +
  //           Math.cos(BbitMapHelper._toRad(toLat)) *
  //             Math.cos(BbitMapHelper._toRad(fromLat)) *
  //             Math.cos(BbitMapHelper._toRad(fromLon) - BbitMapHelper._toRad(toLon)),
  //       ),
  //     ) * BbitMapHelper._constants.EARTH_RADIUS;

  //   return BbitUnit.from(Math.round(distance / accuracy) * accuracy, 'meter');
  // }

  // static getCenter(coords: IBbitGeoCoordinates[]): IBbitGeoCoordinates {
  //   if (Array.isArray(coords) === false || coords.length === 0) {
  //     throw new Error('Coords not provided');
  //   }

  //   const numberOfPoints = coords.length;

  //   const sum = coords.reduce(
  //     (acc, point) => {
  //       const pointLat = BbitMapHelper._toRad(point.lat);
  //       const pointLon = BbitMapHelper._toRad(point.lng);

  //       return {
  //         X: acc.X + Math.cos(pointLat) * Math.cos(pointLon),
  //         Y: acc.Y + Math.cos(pointLat) * Math.sin(pointLon),
  //         Z: acc.Z + Math.sin(pointLat),
  //       };
  //     },
  //     { X: 0, Y: 0, Z: 0 },
  //   );

  //   const X = sum.X / numberOfPoints;
  //   const Y = sum.Y / numberOfPoints;
  //   const Z = sum.Z / numberOfPoints;

  //   return {
  //     lng: BbitMapHelper._toDeg(Math.atan2(Y, X)),
  //     lat: BbitMapHelper._toDeg(Math.atan2(Z, Math.sqrt(X * X + Y * Y))),
  //   };
  // }

  // static getBounds(coords: IBbitGeoCoordinates[]): IBbitGeoBounds {
  //   if (Array.isArray(coords) === false || coords.length === 0) {
  //     throw new Error('Coords not provided');
  //   }

  //   return coords.reduce(
  //     (stats, point) => {
  //       const latitude = point.lat;
  //       const longitude = point.lng;
  //       return {
  //         maxLat: Math.max(latitude, stats.maxLat),
  //         minLat: Math.min(latitude, stats.minLat),
  //         maxLng: Math.max(longitude, stats.maxLng),
  //         minLng: Math.min(longitude, stats.minLng),
  //       };
  //     },
  //     {
  //       maxLat: -Infinity,
  //       minLat: Infinity,
  //       maxLng: -Infinity,
  //       minLng: Infinity,
  //     },
  //   );
  // }
}
